import actions from './actions'
import mutations from './mutations'
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { computed } from "vue";
dayjs.extend(isBetween)

const state = {
  loginBox: {
    show: false,
    method: 'login'
  },
  signPopup: {
    show: false
  },
  palcodePopup: {
    show: false
  },
  palcodeSuccessPopup: {
    show: false
  },
  nicknameEditPopup: {
    show: false
  },
  avatarUploadPopup: {
    show: false
  },
  // Loading popup
  loading: {
    show: false, // 出现
    mask: false
  },
  loadingCount: 0,
  showFifaFlag: true,
  showFifaForce: false,
  // 2023 新春裝飾
  inNewYear2023: computed(() => {
    return dayjs().isBetween('2023-01-13', '2023-02-05', 'day', '[)')
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
